class TSHA_GSAP_Animations {

    constructor() {
        this.init();
    }

    init() { 

        if (typeof gsap === 'undefined') return;

        gsap.config({ nullTargetWarn: false }); 
        document.body.classList.add("gsap-active");

        this.setupSmoothScrollWrappers();
        this.setupStickyService();
        this.setupArcInteractive(); 
        this.setupOverlayPlik(); 
        this.popUpButton(); 
        this.shopifySupport();
    }

    // =========================
    // 🔥 ULTRA SMOOTH SCROLL
    // =========================
    setupSmoothScrollWrappers() {   

        if (typeof Lenis === "undefined") return;

        const lenis = new Lenis({
            duration: 1.6,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smooth: true,
            smoothTouch: true,
            direction: 'vertical',
            gestureDirection: 'vertical',
            wheelMultiplier: 0.8,
            touchMultiplier: 1.5,
        });

        // ✅ GSAP sync (VERY IMPORTANT)
        lenis.on('scroll', ScrollTrigger.update);

        gsap.ticker.add((time)=>{
            lenis.raf(time * 1000);
        });

        gsap.ticker.lagSmoothing(0);
    }

    // =========================
    // SERVICE
    // =========================
    setupStickyService() {

        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

        gsap.registerPlugin(ScrollTrigger);

        document.querySelectorAll(".xt_sticky_with_pin").forEach((section, sectionIndex) => {

            if (section.classList.contains("gsap-service-init")) return;
            section.classList.add("gsap-service-init");

            const items = gsap.utils.toArray(section.querySelectorAll(".services-item"));

            if (window.innerWidth < 768) {
                items.forEach(item => item.style.opacity = 1);
                return;
            }

            const totalScroll = items.length * 300;

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    end: "+=" + totalScroll,
                    scrub: 1, // 🔥 smoother scrub
                    pin: true,
                    pinSpacing: true,
                    invalidateOnRefresh: true,
                    anticipatePin: 1,
                    markers: false,
                    id: "service-" + sectionIndex
                }
            });

            items.forEach((item, index) => {
                tl.to(item, {
                    opacity: 1,
                    duration: 0.4,
                    ease: "power2.out",
                    onStart: () => {
                        items.forEach((el, i) => {
                            if (i <= index) el.style.opacity = 1;
                        });
                    }
                });
            });

        });

        ScrollTrigger.refresh();
    }

    // =========================
    // ARC INTERACTIVE
    // =========================
    setupArcInteractive() {

        if( typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {

            gsap.registerPlugin(ScrollTrigger); 

            document.querySelectorAll(".mt-e-scroll-interactive").forEach(el => {
                el.removeAttribute("data-aos");
                el.classList.remove("aos-init", "aos-animate");
                el.classList.add("no-aos");

                ScrollTrigger.create({
                    trigger: el,
                    start: "top top",
                    end: "bottom 80%",
                    markers: false,
                    onEnter: ()=> ScrollTrigger.refresh()
                });
            });

            const items = gsap.utils.toArray(".mt-e-scroll-item-title");
            const itemsBatge = gsap.utils.toArray(".mt-e-main .mt-e-image");

            const totalHeight = window.innerHeight * items.length;

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: ".mt-e-scroll-item-title",
                    start: "top top",
                    end: "+=" + totalHeight,
                    scrub: 1,
                    pin: true,
                    markers: false
                }
            });

            items.forEach((item, index) => {
                tl.to(item, {
                    opacity: 0,
                    duration: 0.4,
                    ease: "power2.out",
                    onStart: () => {
                        for (let i = 0; i <= index; i++) {
                            items[i].style.opacity = 0;
                        }
                    }
                });
            });

            let mt = gsap.timeline({
                scrollTrigger: {
                    trigger: ".mt-e-image",
                    start: "top 50%",
                    end: "top top",
                    scrub: 1,
                    markers: false
                }
            });

            itemsBatge.forEach((mtItem) => {
                mt.to(mtItem, {
                    scale: 0.6,
                    duration: 0.4,
                    ease: "power2.out"
                });
            });
        }
    }

    // =========================
    // OVERLAY
    // =========================
    setupOverlayPlik() {

        if( typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' ) { 

            gsap.registerPlugin(ScrollTrigger);

            let parOverlay = document.querySelectorAll('.xt_overlay_plik');

            parOverlay.forEach((item) => {

                let parOverlayItem = item.querySelector('.parallax-banner__wraper');

                let parOverlayEle = document.createElement('div');
                parOverlayEle.className = 'xt-cover';
                parOverlayItem.prepend(parOverlayEle);

                gsap.set(parOverlayEle, { opacity: 1 });
    
                gsap.fromTo(parOverlayEle, 
                    { opacity: 1 },
                    { 
                        opacity: 0,
                        ease: "none",
                        scrollTrigger: {
                            trigger: item,
                            start: "top 70%",
                            end: "bottom 80%",
                            scrub: 1
                        }
                    }
                );
            });
        }
    }

    // =========================
    // SHOPIFY SUPPORT
    // =========================
    shopifySupport() {

        document.addEventListener("shopify:section:load", () => {
            setTimeout(() => {
                this.reInitServiceOnly();
            }, 200);
        });
    }

    reInitServiceOnly() {

        if (typeof ScrollTrigger === 'undefined') return;

        ScrollTrigger.getAll().forEach(trigger => {
            if (trigger.vars.id && trigger.vars.id.includes("service-")) {
                trigger.kill();
            }
        });

        document.querySelectorAll(".xt_sticky_with_pin").forEach(section => {
            section.classList.remove("gsap-service-init");
        });

        this.setupStickyService();
    }

    popUpButton() {}
}


// =========================
// INIT
// =========================
window.addEventListener('load', function() {
    setTimeout(() => {
        if (!window.tSha_Initialized) {
            new TSHA_GSAP_Animations();
            window.tSha_Initialized = true;
        }
    }, 100);
});

function initDropdownScroll() {
  document.querySelectorAll(".Vtl-Dropdown__Portal-List").forEach(el => {
    el.style.overflowY = "auto";

    el.addEventListener("wheel", function(e) {
      e.stopPropagation();
    });
  });
}

// Load + refresh
window.addEventListener("load", initDropdownScroll);
document.addEventListener("DOMContentLoaded", initDropdownScroll);

// 🔥 CLICK EVENT (main fix)
document.addEventListener("click", function(e) {
  const header = e.target.closest(".Vtl-Dropdown__Header");

  if (header) {
    // wait for dropdown open animation / DOM update
    setTimeout(() => {
      initDropdownScroll();
    }, 100);
  }
});